import React from 'react';
import CustomModal from '../../../../../components/CustomModal';
import { IOperacoesPatioEntradaSaidaVeiculosSPE } from '../types/types';
import Form from './Form';

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  onClear: () => void;
  onConfirm: () => void;
  selectedRow?: IOperacoesPatioEntradaSaidaVeiculosSPE;
}

const Create: React.FC<Props> = (props: Props) => {
  return (
    <CustomModal title={props.isEdit ? "Editar Entrada e Saída de Veículo SPE" : "Cadastrar Entrada e Saída de Veículo SPE"} onClose={props.onClear}>
      <Form
        isView={props.isView}
        selectedRow={props.selectedRow}
        onConfirm={props.onConfirm}
        isEdit={props.isEdit}
        onClose={props.onClear}
      />
    </CustomModal>
  );
};

export default Create;
